// extracted by mini-css-extract-plugin
module.exports = {"SectionHeader":"SectionHeader-module__SectionHeader___NY9TR"};